module.exports = __webpack_public_path__ + "img/rectangles-mixed.e1c328a6.svg";